module.exports = __webpack_public_path__ + "img/mythical.8368475a.png";